// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../../user/v1/user";
/**
 * The request message for listing app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnersRequest
 */
export interface ListAppEntitlementOwnersRequest {
    /**
     * The page_size field for pagination.
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The app_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string entitlement_id = 4
     */
    entitlementId: string;
}
/**
 * The response message for listing app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnersResponse
 */
export interface ListAppEntitlementOwnersResponse {
    /**
     * The list of owners for the app entitlement.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * The request message for listing app entitlement owner IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsRequest
 */
export interface ListAppEntitlementOwnerIDsRequest {
    /**
     * The page_size field for pagination.
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The app_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string entitlement_id = 4
     */
    entitlementId: string;
}
/**
 * The response message for listing app entitlement owners IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsResponse
 */
export interface ListAppEntitlementOwnerIDsResponse {
    /**
     * The list of owner IDs for the app entitlement.
     *
     * @generated from protobuf field: repeated string user_ids = 1
     */
    userIds: string[];
}
/**
 * The request message for adding an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.AddAppEntitlementOwnerRequest
 */
export interface AddAppEntitlementOwnerRequest {
    /**
     * The app_id field for the app entitlement to add the owner to.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to add the owner to.
     *
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
    /**
     * The user_id field for the user to add as an owner of the app entitlement.
     *
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
}
/**
 * The empty response message for adding an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.AddAppEntitlementOwnerResponse
 */
export interface AddAppEntitlementOwnerResponse {
}
/**
 * The empty response message for setting the app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppEntitlementOwnersResponse
 */
export interface SetAppEntitlementOwnersResponse {
}
/**
 * The request message for setting the app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppEntitlementOwnersRequest
 */
export interface SetAppEntitlementOwnersRequest {
    /**
     * The app_id field for the app entitlement to set the owners of.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to set the owners of.
     *
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
    /**
     * The user_ids field for the users to set as an owner of the app entitlement.
     *
     * @generated from protobuf field: repeated string user_ids = 3
     */
    userIds: string[];
}
/**
 * The request message for removing an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerRequest
 */
export interface RemoveAppEntitlementOwnerRequest {
    /**
     * The app_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
    /**
     * The user_id field for the user to remove as an owner of the app entitlement.
     *
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
}
/**
 * The empty response message for removing an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerResponse
 */
export interface RemoveAppEntitlementOwnerResponse {
}
/**
 * The request message for deleting app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersRequest
 */
export interface DeleteAppEntitlementOwnersRequest {
    /**
     * The app_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
}
/**
 * the empty response message for deleting app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersResponse
 */
export interface DeleteAppEntitlementOwnersResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnersRequest$Type extends MessageType<ListAppEntitlementOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementOwnersRequest>): ListAppEntitlementOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementOwnersRequest): ListAppEntitlementOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 4:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 4; */
        if (message.entitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnersRequest
 */
export const ListAppEntitlementOwnersRequest = new ListAppEntitlementOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnersResponse$Type extends MessageType<ListAppEntitlementOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementOwnersResponse>): ListAppEntitlementOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementOwnersResponse): ListAppEntitlementOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnersResponse
 */
export const ListAppEntitlementOwnersResponse = new ListAppEntitlementOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnerIDsRequest$Type extends MessageType<ListAppEntitlementOwnerIDsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnerIDsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementOwnerIDsRequest>): ListAppEntitlementOwnerIDsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementOwnerIDsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementOwnerIDsRequest): ListAppEntitlementOwnerIDsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 4:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementOwnerIDsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 4; */
        if (message.entitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsRequest
 */
export const ListAppEntitlementOwnerIDsRequest = new ListAppEntitlementOwnerIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnerIDsResponse$Type extends MessageType<ListAppEntitlementOwnerIDsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnerIDsResponse", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementOwnerIDsResponse>): ListAppEntitlementOwnerIDsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementOwnerIDsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementOwnerIDsResponse): ListAppEntitlementOwnerIDsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string user_ids */ 1:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementOwnerIDsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string user_ids = 1; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsResponse
 */
export const ListAppEntitlementOwnerIDsResponse = new ListAppEntitlementOwnerIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppEntitlementOwnerRequest$Type extends MessageType<AddAppEntitlementOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.AddAppEntitlementOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AddAppEntitlementOwnerRequest>): AddAppEntitlementOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AddAppEntitlementOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAppEntitlementOwnerRequest): AddAppEntitlementOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAppEntitlementOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppEntitlementOwnerRequest
 */
export const AddAppEntitlementOwnerRequest = new AddAppEntitlementOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppEntitlementOwnerResponse$Type extends MessageType<AddAppEntitlementOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.AddAppEntitlementOwnerResponse", []);
    }
    create(value?: PartialMessage<AddAppEntitlementOwnerResponse>): AddAppEntitlementOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AddAppEntitlementOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAppEntitlementOwnerResponse): AddAppEntitlementOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAppEntitlementOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppEntitlementOwnerResponse
 */
export const AddAppEntitlementOwnerResponse = new AddAppEntitlementOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementOwnersResponse$Type extends MessageType<SetAppEntitlementOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppEntitlementOwnersResponse", []);
    }
    create(value?: PartialMessage<SetAppEntitlementOwnersResponse>): SetAppEntitlementOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SetAppEntitlementOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppEntitlementOwnersResponse): SetAppEntitlementOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppEntitlementOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppEntitlementOwnersResponse
 */
export const SetAppEntitlementOwnersResponse = new SetAppEntitlementOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementOwnersRequest$Type extends MessageType<SetAppEntitlementOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppEntitlementOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App_Entitlement_Owner" } }] } });
    }
    create(value?: PartialMessage<SetAppEntitlementOwnersRequest>): SetAppEntitlementOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SetAppEntitlementOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetAppEntitlementOwnersRequest): SetAppEntitlementOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                case /* repeated string user_ids */ 3:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetAppEntitlementOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        /* repeated string user_ids = 3; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppEntitlementOwnersRequest
 */
export const SetAppEntitlementOwnersRequest = new SetAppEntitlementOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppEntitlementOwnerRequest$Type extends MessageType<RemoveAppEntitlementOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAppEntitlementOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RemoveAppEntitlementOwnerRequest>): RemoveAppEntitlementOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RemoveAppEntitlementOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAppEntitlementOwnerRequest): RemoveAppEntitlementOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAppEntitlementOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerRequest
 */
export const RemoveAppEntitlementOwnerRequest = new RemoveAppEntitlementOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppEntitlementOwnerResponse$Type extends MessageType<RemoveAppEntitlementOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAppEntitlementOwnerResponse", []);
    }
    create(value?: PartialMessage<RemoveAppEntitlementOwnerResponse>): RemoveAppEntitlementOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveAppEntitlementOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAppEntitlementOwnerResponse): RemoveAppEntitlementOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAppEntitlementOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerResponse
 */
export const RemoveAppEntitlementOwnerResponse = new RemoveAppEntitlementOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementOwnersRequest$Type extends MessageType<DeleteAppEntitlementOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAppEntitlementOwnersRequest>): DeleteAppEntitlementOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementOwnersRequest): DeleteAppEntitlementOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersRequest
 */
export const DeleteAppEntitlementOwnersRequest = new DeleteAppEntitlementOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementOwnersResponse$Type extends MessageType<DeleteAppEntitlementOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementOwnersResponse", []);
    }
    create(value?: PartialMessage<DeleteAppEntitlementOwnersResponse>): DeleteAppEntitlementOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementOwnersResponse): DeleteAppEntitlementOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersResponse
 */
export const DeleteAppEntitlementOwnersResponse = new DeleteAppEntitlementOwnersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementOwners
 */
export const AppEntitlementOwners = new ServiceType("c1.api.app.v1.AppEntitlementOwners", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppEntitlementOwners", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Entitlement Owner", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppEntitlementOwnersRequest, O: ListAppEntitlementOwnersResponse },
    { name: "ListOwnerIDs", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Entitlement_Owner", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Entitlement Owner" }] } }, I: ListAppEntitlementOwnerIDsRequest, O: ListAppEntitlementOwnerIDsResponse },
    { name: "Add", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", group: "App Entitlement Owner" }] } }, I: AddAppEntitlementOwnerRequest, O: AddAppEntitlementOwnerResponse },
    { name: "Set", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Entitlement_Owner" }], group: "App Entitlement Owner" }] } }, I: SetAppEntitlementOwnersRequest, O: SetAppEntitlementOwnersResponse },
    { name: "Remove", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners/{user_id}", group: "App Entitlement Owner" }] } }, I: RemoveAppEntitlementOwnerRequest, O: RemoveAppEntitlementOwnerResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Entitlement_Owner" }], group: "App Entitlement Owner" }] } }, I: DeleteAppEntitlementOwnersRequest, O: DeleteAppEntitlementOwnersResponse }
]);
